module.exports = __webpack_public_path__ + "img/gq.a695cd66.svg";